// extracted by mini-css-extract-plugin
export default {"empresa":"Company_empresa__P7qzl"};